import angular from 'angular';
import uiRouter from 'angular-ui-router';
import aboutComponent from './about.component';

let aboutModule = angular.module('about', [
  uiRouter
]).component('about', aboutComponent);

export default aboutModule;



// WEBPACK FOOTER //
// ./app/components/about/about.js